<template>
	<div>
		<div class="p-2 border-gray br4" style="width: 350px;">
			<video src="https://csimg.boyanhy.com/6d7969589278df7234d2c293f1d7c53c1762927395.mp4" autoplay controls
				class="bd-placeholder-img card-img-top" style="width: 100%;height: 185px;"></video>
			<div class="cl-theme ft26 ftw600 text-center">
				{{$t('teacherVue.halfPrice')}} {{getCurrency()}}55+
				<span class="ftw400 ft14 cl-black">/25{{$t('forClassIndex.minute')}}</span>
			</div>
			<div class="mt-3 btn btn-theme wid-100" @click="buyForModal?openModal():buyClassTest()">
				{{$t('teacherVue.bookImmediately')}}
			</div>
			<!-- <div class="mt-1 text-center">
				{{$t('teacherVue.freeProgram')}}
				<span class="cl-red">只剩2個位！</span>
			</div> -->
			<div class="mt-3 btn btn-outline-gray wid-100" @click="setCollect">
				{{!isCollect?$t('teacherVue.favoriteMentor'):$t('teacherVue.savedFavorites')}}
			</div>
			<!-- <div class="mt-3 btn btn-outline-gray wid-100" @click="openKefu(user_id)">
				{{$t('teacherVue.contactMentor')}}
			</div> -->
		</div>

		<a-modal :title="null" v-model="showModal" :footer="null" :closable="false" @cancel="showModal=false" :width="800">
			<a-spin :spinning="codeLoading">
				<div class="flex mt-2">
					<div class="py-1 px-3 clickAct" v-for="(item,index) in formTeacherC" @click="changeClassType(item) "
						:class="formTeacherTypeId==item.id?'bg-theme border-theme cl-w':'bg-F3F3F3 border-gray'">
						{{item.name}}
					</div>
				</div>
				
				<div class="mt-2 row ft14 flex alcenter clickAct" v-for="(it,ind) in formTeacherItem" :key="ind">
					<div class="col-md-2">
						{{it.name}}
					</div>
					<div class="col-md py-2 flex wrap">
						<div v-for="itChild in it.teacherCourse" @click="buyClass(it.id,it.name,itChild)" style="width: 100px;" >
							<div class="p-2 ml10" style="height: 40px;" v-if="itChild.is_experience=='1'">{{$t('common.experienceClass')}}</div>
							<div class="p-2 ml10" style="height: 40px;" v-else-if="itChild.is_experience=='2'">
								{{$t('teacherVue.formalClasses')}}
							</div>
							<div class="p-2 ml10" style="height: 40px;" v-else>
								
							</div>
							<div class="border-gray br8 wid-fit p-1 ml5 mt-1" >
								<div class="ftw600">
									{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
								</div>
								<div class="cl-info ft10" v-if="itChild.is_experience=='2'">
									<!-- {{itChild.quantity}}堂50分鐘課 -->
									{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
								</div>
								<div class="cl-info ft10" v-else>
									 {{$t('common.teatClasstime')}}
								</div>
								<div class="border-theme py-0 px-3 cl-theme ft10 wid-fit" >
									{{itChild.discount}}% off
								</div>
							</div>
						</div>
						
					</div>
				</div>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			teacher_id: {
				type: Number,
				default: 0
			},
			teacherName: {
				type: String,
				default: ''
			},
			teacherPhoto: {
				type: String,
				default: ''
			},
			testPrice: {
				type: Number,
				default: 0
			},
			teacher_course_id: {
				type: Number,
				default: 0
			},
			user_id: {
				type: Number,
				default: 0
			},
			buyForModal: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isCollect: false,
				showModal: false,
				formTeacherC: [],
				formTeacherTypeId: 0,
				formTeacherTypeName: '',
				formTeacherItem: {},
				form: {},
				codeLoading:false
			}
		},
		created() {
			// console.log("this.userInfo",this.userInfo);
		},
		methods: {
			buyClassTest() {
				this.$router.push('/cashDesk?test=1&teacherId=' + this.teacher_id + '&teacherName=' + this.teacherName +
					'&teacherPhoto=' + this.teacherPhoto + '&testPrice=' + this.testPrice + '&teacher_course_id=' +
					this.teacher_course_id)
			},
			setCollect() {
				this.$http.api('teachers/collect', {
					teacher_id: this.teacher_id,
				}).then(res => {
					this.isCollect = !this.isCollect
				})
			},
			openModal() {
				this.showModal = true
				this.codeLoading = true
				this.getTeacherDeatail()
				this.getClassifyList()
			},
			async getTeacherDeatail() {
				await this.$http.api('teachers/teacherDeatail', {
					teacher_id: this.teacher_id
				}).then(res => {
					this.form = res.info
					// this.form.is_cloaking=='1'?this.isCollect=true:this.isCollect=false
				})
			},
			// 课程分类
			async getClassifyList(teacherCourse) {
				await this.$http.api('course/classifyList', {
					teacherCourse: this.teacher_id,
					includeCourse: 1, //返回老师课程信息
				}).then(res => {
					this.formTeacherC = res.list
					this.formTeacherTypeId = res.list[0].id
					this.formTeacherTypeName = res.list[0].name
					this.formTeacherItem = res.list[0].course
					this.codeLoading = false
				})
			},
			changeClassType(item) {
				this.formTeacherItem = item.course;
				this.formTeacherTypeId = item.id;
				this.formTeacherTypeName = item.name
			},
			buyClass(id, name, item) {
				this.$router.push('/cashDesk?teacherId=' + this.teacher_id + '&teacherName=' + this.form.name +
					'&teacherPhoto=' + this.form.photo_image +'&test='+item.is_experience+'&teacher_course_id=' +item.id+
					'&course_id=' + id + '&course_name=' + name + '&course_classify_id=' + this.formTeacherTypeId +
					'&course_classify_name=' + this.formTeacherTypeName + '&item=' + JSON.stringify(item))

			},
			buyClassTest() {
				this.$router.push('/cashDesk?test=1&teacherId=' + this.teacher_id + '&teacherName=' + this.form.name +
					'&teacherPhoto=' + this.form.photo_image + '&testPrice=' + this.form.experience_price +
					'&teacher_course_id=' + this.teacher_course_id)
			}
		}
	}
</script>

<style>
</style>